import React, { useCallback } from 'react';
import MFASelectChannel from 'components/common/MFA/MFASelectChannel';
import Page, { AUTH_TYPE } from 'components/common/Page';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { FormattedRichMessage, ContentPage, LoadingPage, usePathBuilder, useRichIntl } from 'ciam-self-service-shared';
import onDemandAuthTree, { REDIRECT_SUCCESS } from '../authTree';
import useAuthTreeErrorHandler from '../useAuthTreeErrorHandler';
import OnDemandBackButton from './OnDemandBackButton';
import useSelectChannel from '../../common/MFA/useSelectChannel';
import useOnDemandOtpType from '../useOnDemandOtpType';
import PropTypes from 'prop-types';

function OnDemandSelectChannelPage(props) {
  const { handleReset } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const pathBuilder = usePathBuilder();
  const type = useOnDemandOtpType();
  const intl = useRichIntl();
  const authTreeErrorHandler = useAuthTreeErrorHandler();
  const onSelectChannel = useCallback(
    async (_, payload) => {
      const { stage, otpchannel } = payload;
      try {
        const step = await onDemandAuthTree.chooseChannel(dispatch, stage, otpchannel);
        if (step && typeof step === 'object') {
          // Only navigate if step is an actual step object
          history.push(pathBuilder('/otp-on-demand/enter', true, { searchParams: { type } }));
        } else if (step === REDIRECT_SUCCESS) {
          // Do nothing, WebAuthn redirect in progress
        } else {
          // Need this to reset the on-demand auth tree, else the tree will on webauthn
          handleReset();
        }
      } catch (err) {
        authTreeErrorHandler(err);
      }
    },
    [dispatch, history, pathBuilder, type, handleReset, authTreeErrorHandler],
  );

  const [channels, handleSelectChannel, displayChoices] = useSelectChannel(onSelectChannel);

  return (
    <Page
      title={intl.formatMessage({ id: 'mfa.selectChannel.page.title' })}
      authType={AUTH_TYPE.AUTHENTICATED}
      showLangToggle={false}
      showRealmToggle={false}
      showContactUs={false}
      showManageId={false}
      heading={intl.formatMessage({ id: 'mfa.selectChannel.page.heading' })}
    >
      {displayChoices ? (
        <ContentPage
          heading={<FormattedRichMessage id="mfa.selectChannel.page.heading" />}
          backButton={<OnDemandBackButton />}
        >
          <MFASelectChannel
            channels={channels}
            onSelectChannel={handleSelectChannel}
            url={pathBuilder('/otp-on-demand/enter', true, { searchParams: { type } })}
          />
        </ContentPage>
      ) : (
        <LoadingPage />
      )}
    </Page>
  );
}
OnDemandSelectChannelPage.propTypes = {
  handleReset: PropTypes.func.isRequired,
};

export default OnDemandSelectChannelPage;
